/**
 * BlueSolution Subscription Management API
 * Last changed: 2025-03-05T10:54:50+00:00
 *
 * OpenAPI spec version: 1.0.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CustomerContactDetails } from './customerContactDetails';

export interface CustomerSalesPartner { 
    name: string;
    knr: string;
    /**
     * image as base64
     */
    companyLogoImg?: string;
    signatureImg?: string;
    websiteUrl?: string;
    faxNr?: string;
    ustIdNr?: string;
    taxNr?: string;
    shareHolder?: string;
    commercialRegister?: string;
    registerCourt?: string;
    id?: number;
    contactDetails?: CustomerContactDetails;
}